import { faGlobe } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from 'components/DropdownMenu'

import i18n, { useTranslation } from 'services/i18n'

import { LanguageOption } from './LanguageOption'
import { useLanguageAndCountrySelector } from './useLanguageAndCountrySelector'

export const LanguageSelector = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu.language_selector',
  })

  const { onSelectLanguage, languageOptions, currentCountry } = useLanguageAndCountrySelector()

  if (!languageOptions || languageOptions?.length < 2) {
    return null
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <FontAwesomeIcon icon={faGlobe} className="mr-2 w-4" />
        {t('header')}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {languageOptions.map(option => (
          <LanguageOption
            isSelected={option.language === i18n.language && option.country === currentCountry}
            language={option.language}
            country={option.country}
            key={`${option.country}-${option.language}`}
            onSelect={onSelectLanguage}
          />
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
